import * as metaStateUtils from '../../../../store/util/metaStateUtils';


/**
 * @param state {object} Domain state
 * @param cart {object} Cart payload
 * @returns {object} Updated domain state
 */
export default (state, cart) => {

    state.carts[cart.id] = cart;
    state.carts = metaStateUtils.setIsLoaded(state.carts);

    return state;
};
